import { Type } from '@angular/core';
import {
  FluentAssignMethod,
  privateKey,
  extend,
  arrayUnion
} from 'angular2-modal';
import { VEXModalContext, VEXModalContextBuilder } from '../modal-context';
import { Modal } from '../modal';
import {
  DialogFormModal as component,
  VEXButtonHandler,
  VEXButtonConfig
} from '../dialog-form-modal';


const /** @type {?} */ DEFAULT_SETTERS = [
  'content'
];
/**
 * Data definition
 */
export class DialogPreset extends VEXModalContext {
  defaultResult: any;
  content: Type<any>;
  buttons: VEXButtonConfig[];
  showInput: any;
}

function DialogPreset_tsickle_Closure_declarations() {
/** @type {?} */
DialogPreset.prototype.defaultResult;
/** @type {?} */
DialogPreset.prototype.content;
/** @type {?} */
DialogPreset.prototype.buttons;
/** @type {?} */
DialogPreset.prototype.showInput;
}

/**
 * A Preset representing the configuration needed to open MessageModal.
 * This is an abstract implementation with no concrete behaviour.
 * Use derived implementation.
 */
export class DialogPresetBuilder<T extends DialogPreset>
extends VEXModalContextBuilder<T> {
/**
 * the message to display on the modal.
 */
content: FluentAssignMethod<Type<any>, this>;
/**
 * @param {?} modal
 * @param {?=} defaultValues
 * @param {?=} initialSetters
 * @param {?=} baseType
 */
constructor(modal: Modal,
              defaultValues: T = undefined,
              initialSetters: string[] = undefined,
              baseType: new () => T = undefined) {
    super(
      extend<any>({modal, component, buttons: [], defaultResult: true}, defaultValues || {}),
      arrayUnion<string>(DEFAULT_SETTERS, initialSetters || []),
      baseType || <any>DialogPreset // https://github.com/Microsoft/TypeScript/issues/7234
    );
  }
/**
 * @param {?} css
 * @param {?} caption
 * @param {?} onClick
 * @return {?}
 */
addButton(css: string, caption: string, onClick: VEXButtonHandler): this {
    let /** @type {?} */ btn = {
      cssClass: css,
      caption: caption,
      onClick: onClick
    };

    let /** @type {?} */ key = privateKey('buttons');
    ( /** @type {?} */((this[key] as VEXButtonConfig[]))).push(btn);

    return this;
  }
/**
 * @param {?=} text
 * @return {?}
 */
addOkButton(text: string = 'OK'): this {
    this.addButton(
      'vex-dialog-button-primary vex-dialog-button vex-first',
      text,
      (cmp: component, $event: MouseEvent) => cmp.dialog.close(cmp.dialog.context.defaultResult)
    );
    return this;
  }
/**
 * @param {?=} text
 * @return {?}
 */
addCancelButton(text: string = 'CANCEL'): this {
    this.addButton(
      'vex-dialog-button-secondary vex-dialog-button vex-last',
      text,
      (cmp: component, $event: MouseEvent) => cmp.dialog.dismiss()
    );
    return this;
  }
}

function DialogPresetBuilder_tsickle_Closure_declarations() {
/**
 * the message to display on the modal.
 * @type {?}
 */
DialogPresetBuilder.prototype.content;
}

